import React from "react";
import { Box } from "@mui/material";
import { GridColDef, GridToolbar } from "@mui/x-data-grid-premium";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import HistoryArea from "./HistoryArea";

interface ServiceGridAreaProps {
  currentView: "main" | "subcategory" | "history" | "frequent";
  rowID: string;
  onHistoryServiceToggle: (id: number | string, service?: any, originalId?: number | string) => void;
  selectedHistoryServices: (number | string)[];
  setSelectedHistoryServices: React.Dispatch<React.SetStateAction<(number | string)[]>>;
  onHistoryParentToggle: (parentId: number | string, children?: any[]) => void;
  searchText: string;
  gridData: any[];
  columns: GridColDef[];
  loading: boolean;
}

const ServiceGridArea: React.FC<ServiceGridAreaProps> = ({
  currentView,
  rowID,
  onHistoryServiceToggle,
  selectedHistoryServices,
  setSelectedHistoryServices,
  onHistoryParentToggle,
  searchText,
  gridData,
  columns,
  loading,
}) => {
  return (
    <Box sx={{ width: "100%", mb: 0, pb: 0, height: "65vh", overflow: "hidden", "& .MuiDataGrid-root": { mb: 0, height: "100%" } }}>
      {currentView === "history" && (
        <HistoryArea
          rowID={rowID}
          onHistoryServiceToggle={onHistoryServiceToggle}
          selectedHistoryServices={selectedHistoryServices}
          setSelectedHistoryServices={setSelectedHistoryServices}
          onHistoryParentToggle={onHistoryParentToggle}
          searchText={searchText}
        />
      )}
      {currentView !== "history" && (
        <Box
          sx={{
            flex: 1,
            width: "100%",
            maxHeight: "65vh",
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
            position: "relative",
          }}
        >
          <ByzMuiDataGrid
            rows={searchText ? gridData.filter((row: any) =>
              (row.name && row.name.toLocaleLowerCase("tr-TR").includes(searchText.toLocaleLowerCase("tr-TR"))) ||
              (row.code && String(row.code).includes(searchText))
            ) : gridData}
            columns={columns}
            pagination
            initialState={{
              pagination: {
                paginationModel: { pageSize: 25, page: 0 },
              },
            }}
            pageSizeOptions={[10, 25, 50, 100]}
            getRowId={(row) => row.id}
            checkboxSelection={false}
            disableColumnMenu={false}
            autoHeight
            getRowHeight={() => 40}
            enableRowZoom={true}
            loading={loading}
            disableVirtualization={false}
            rowSelectionModel={[]}
            hideFooterSelectedRowCount={true}
            whiteGrid={true}
            slots={{
              toolbar: GridToolbar,
            }}
            sx={{
              width: "100%",
              pointerEvents: loading ? "none" : "auto",
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default ServiceGridArea;

